import { getDriverDocumentLabelFr } from "./document-status";

/**
 * GraphQL `extensions.code` returned when a driver paused for an expired
 * document tries to take (or is given) new work.
 */
export const DRIVER_WORK_PAUSED_ERROR_CODE = "DRIVER_DOCUMENT_EXPIRY_PAUSED";

export const DRIVER_WORK_PAUSED_MESSAGE_FR =
  "Compte en pause : un document a expiré. Les nouvelles missions sont bloquées jusqu'à la validation du document renouvelé.";

/** French driver banner / refusal copy, naming the expired document when known. */
export function driverPausedMessageFr(documentName?: string | null): string {
  if (!documentName) return DRIVER_WORK_PAUSED_MESSAGE_FR;
  return `Compte en pause : votre document ${getDriverDocumentLabelFr(documentName)} a expiré. Envoyez la version renouvelée depuis votre profil.`;
}

const record = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === "object" && value !== null ? (value as Record<string, unknown>) : undefined;

/**
 * Recognizes the pause refusal across client error shapes: an error carrying
 * `code` (mobile/admin fetchers), graphql-request `response.errors`, Apollo
 * `graphQLErrors`, or the code/message in a plain error message.
 */
export function isDriverWorkPausedError(error: unknown): boolean {
  const err = record(error);
  if (!err) return false;
  if (err.code === DRIVER_WORK_PAUSED_ERROR_CODE) return true;
  const graphQLErrors = [
    ...((record(err.response)?.errors as unknown[] | undefined) ?? []),
    ...((err.graphQLErrors as unknown[] | undefined) ?? []),
  ];
  if (
    graphQLErrors.some((e) => record(record(e)?.extensions)?.code === DRIVER_WORK_PAUSED_ERROR_CODE)
  )
    return true;
  const message = typeof err.message === "string" ? err.message : "";
  return (
    message.includes(DRIVER_WORK_PAUSED_ERROR_CODE) ||
    message.startsWith(DRIVER_WORK_PAUSED_MESSAGE_FR.slice(0, 40))
  );
}
